module.exports = __webpack_public_path__ + "img/icon-服务区@2x.d99de078.png";